import axios from "axios";

export const getNewComments = async (api, token) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL_USER}/${api}`,

    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};
